import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiPlusCircle, FiDownload } from "react-icons/fi";


import { openS3Document } from "../lib/documents";

function ShareholdersMeetings() {
  const { t } = useTranslation();

  const [openIndex, setOpenIndex] = useState(null);

  const meetingGroups = [
    {
      title: "Shareholders' Meetings 2026",
      files: [
        {
          date: "20 April 2026",
          nameKey:
            "main.shareholdersMeetings.documents.socialBodiesCandidates2026",
          key: "assemblee_soci/2026/2026_candidati_nomina_organi_sociali.pdf",
        },

        {
          date: "28 April 2026",
          nameKey: "main.shareholdersMeetings.documents.notice2026It",
          key: "assemblee_soci/2026/convocazione_assemblea_ordinaria_soci_28_Aprile_2026_IT.pdf",
        },
        {
          date: "28 April 2026",
          nameKey: "main.shareholdersMeetings.documents.notice2026En",
          key: "assemblee_soci/2026/Shareholders_SPA_Meeting_Notice_ENG_formatted.pdf",
        },
        {
          date: "28 April 2026",
          nameKey: "main.shareholdersMeetings.documents.proxy2026It",
          key: "assemblee_soci/2026/delega_assemblea_soci_spa_aprile2026_IT.pdf",
        },
        {
          date: "28 April 2026",
          nameKey: "main.shareholdersMeetings.documents.proxy2026En",
          key: "assemblee_soci/2026/Proxy_Voting_SPA_Form_2026_EN.pdf",
        },
      ],
    },
    {
      title: "Shareholders' Meetings 2025",
      files: [
        {
          date: "28 April 2025",
          nameKey: "main.shareholdersMeetings.documents.proxy2025It",
          key: "assemblee_soci/2025/delega_assemblea_spa_aprile2025_IT.pdf",
        },
        {
          date: "28 April 2025",
          nameKey: "main.shareholdersMeetings.documents.proxy2025En",
          key: "assemblee_soci/2025/delega_assemblea_spa_aprile2025_EN.pdf",
        },
        {
          date: "28 April 2025",
          nameKey:
            "main.shareholdersMeetings.documents.statutoryAuditorsProposal2025",
          key: "assemblee_soci/2025/parere_collegio_nomina_revisore_signed_2025_2027.pdf",
        },
        {
          date: "14 April 2025",
          nameKey: "main.shareholdersMeetings.documents.notice2025It",
          key: "assemblee_soci/2025/Avviso_convocazione_assemblea_ordinaria_soci_30_aprile_2025.docx",
        },
        {
          date: "14 April 2025",
          nameKey: "main.shareholdersMeetings.documents.notice2025En",
          key: "assemblee_soci/2025/Notice_call_ordinary_shareholdes_meeting_30_April_2025.docx",
        },
      ],
    },
    {
      title: "Shareholders' Meetings 2024",
      files: [
        {
          date: "29 April 2024",
          nameKey: "main.shareholdersMeetings.documents.meeting2024It",
          key: "assemblee_soci/2024/assemblea_ordinaria_soci_29_Aprile_2024.docx",
        },
        {
          date: "29 April 2024",
          nameKey: "main.shareholdersMeetings.documents.meeting2024En",
          key: "assemblee_soci/2024/shareholdes_meeting_29_April_2024.docx",
        },
        {
          date: "",
          nameKey:
            "main.shareholdersMeetings.documents.separateFinancialStatements2023",
          key: "financial_reports/2023/bilancio_separato_rigsavespa_revisionato_31_12_2023.pdf",
        },
        {
          date: "",
          nameKey:
            "main.shareholdersMeetings.documents.statutoryAuditorsReport2023",
          key: "assemblee_soci/2024/relazione _collegio_sindacale_bil_2023_rigsavespa.pdf",
        },
      ],
    },
    {
      title: "Shareholders' Meetings 2023",
      files: [
        {
          date: "13 December 2023",
          nameKey: "main.shareholdersMeetings.documents.notice2023En",
          key: "assemblee_soci/2023/Convocazione-Assemblea-soci-dicembre-2023.pdf",
        },
        {
          date: "24 October 2023",
          nameKey: "main.shareholdersMeetings.documents.notice2023It",
          key: "assemblee_soci/2023/20231005_117.pdf",
        },
      ],
    },
  ];

  return (
    <main className="shareholders-page">
      <section className="shareholders-hero">
        <div>
          <h1>{t("main.shareholdersMeetings.title")}</h1>
          <span />
        </div>
      </section>

      <section className="shareholders-list-section">
        <div className="shareholders-list">
          {meetingGroups.map((group, index) => {
            const isOpen = openIndex === index;
            const firstFile = group.files?.[0];

            return (
              <div className="shareholders-row-wrapper" key={group.title}>
                <div className="shareholders-row">
                  <button
                    type="button"
                    className="shareholders-open-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-label={`Open ${group.title}`}
                  >
                    <FiPlusCircle />
                  </button>

                  <button
                    type="button"
                    className="shareholders-name-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    {group.title}
                  </button>

                  {firstFile && (
                    <a
                      href="/"
                      className="shareholders-download"
                      aria-label={`Download ${group.title}`}
                      onClick={(event) => openS3Document(event, firstFile.key)}
                    >
                      <FiDownload />
                    </a>
                  )}
                </div>

                {isOpen && (
                  <div className="shareholders-documents">
                    {group.files.map((file) => (
                      <a
                        key={file.key}
                        href="/"
                        onClick={(event) => openS3Document(event, file.key)}
                      >
                        <span>
                          {t(file.nameKey)}
                          {file.date && <small>{file.date}</small>}
                        </span>

                        <FiDownload />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default ShareholdersMeetings;